import LogoSVG from "./brand/LogoSVG";

const EMBLEM_VIEWBOX = "205 210 400 430";
const FULL_VIEWBOX = "205 210 1250 430";

export const LogoMark = ({ className = "h-10 w-10" }) => (
  <LogoSVG theme="dark" emblemOnly flicker={false} viewBox={EMBLEM_VIEWBOX} className={className} />
);

export const FullLogo = ({ className = "w-[280px] h-auto" }) => (
  <a href="/" data-testid="brand-full-logo" className="inline-block">
    <LogoSVG theme="dark" flicker={false} viewBox={FULL_VIEWBOX} className={className} />
  </a>
);

export const Logo = ({ compact = false }) => (
  <a href="/" data-testid="brand-logo" className="flex items-center gap-3 group">
    <LogoMark className="h-11 w-10 transition-transform duration-500 group-hover:-rotate-6" />
    <span className="leading-none">
      <span className="block font-display font-semibold tracking-[0.18em] text-[13px] sm:text-sm text-[var(--cream)]">
        KASHYAP<span className="text-[var(--mint)]">GREEN</span>FUELS
      </span>
      {!compact && (
        <span className="hidden sm:block mt-1 font-mono text-[10px] tracking-[0.3em] text-[var(--sage)]">
          RENEWABLE ORGANIC MATERIAL
        </span>
      )}
    </span>
  </a>
);
